import type { ReactNode } from 'react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service';
import { messages } from './messages';
import { TOTE } from '../../../../filters/constants';

type CriterionOption = {
  id: string;
  displayName: string | ReactNode;
};

type CriterionArgument = {
  value: string | string[];
  displayName?: string;
};

type CriterionStateMethods = {
  getCriterionOperator: () => CriterionOption;
  updateCriterionOperator: (option: CriterionOption) => void;
  getCriterionArgument: () => CriterionArgument;
  updateCriterionArgument: (argument: CriterionArgument) => void;
};

type CriteriaInformations = {
  selectedFilterBy: { id: string };
  criterionStateMethods: CriterionStateMethods;
  criterionOperatorOptions: CriterionOption[];
  criterionArgumentOptions: Array<CriterionOption & { value: unknown }>;
};

export const Tote = {
  id: TOTE,
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'ToteName',
  displayName: <FormattedMessage {...messages.tote} />,
  render: (criteriaInformations: CriteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
